function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { injectIntl } from 'react-intl';
import cs from 'classnames';
import { ReactComponent as DirectionalArrow } from '../../../icons/DirectionalArrowWithStick/DirectionalArrowWithStick.svg';
import CircleButton from '../../Buttons/CircleButton/CircleButton';
import Icon from '../../Icons/Icon/Icon';
import Tab from '../Tab/Tab';
import { TabContext } from '../Tabs';
import Tooltip from '../../Tips/Tooltip/Tooltip';
import en from './locales/TabListScrollable.en.json';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import { AdditionalIntl } from '../../I18n/AdditionalIntl/AdditionalIntl';
import styles from './TabListScrollable.module.scss';
var MESSAGES = normalizeLocaleData(en, '@dm/components.tabs');
function TabListScrollable(_ref) {
  var align = _ref.align,
    compact = _ref.compact,
    intl = _ref.intl,
    tabs = _ref.tabs;
  var listRef = useRef(null);
  var _useContext = useContext(TabContext),
    selected = _useContext.selected;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentTabIndex = _useState2[0],
    setCurrentTabIndex = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hideArrows = _useState4[0],
    setHideArrows = _useState4[1]; // Left Scroll
  var canScrollLeft = useMemo(function () {
    return currentTabIndex !== 0;
  }, [currentTabIndex]);
  var leftTooltip = useMemo(function () {
    return canScrollLeft ? '@dm/components.tabs.scroll-left' : '@dm/components.tabs.scroll-left-end';
  }, [canScrollLeft]);
  var onScrollLeft = useCallback(function () {
    if (canScrollLeft) {
      setCurrentTabIndex(function (prev) {
        return prev - 1;
      });
    }
  }, [canScrollLeft]);

  // Right Scroll
  var canScrollRight = useMemo(function () {
    return currentTabIndex !== tabs.length - 1;
  }, [currentTabIndex, tabs]);
  var rightTooltip = useMemo(function () {
    return canScrollRight ? '@dm/components.tabs.scroll-right' : '@dm/components.tabs.scroll-right-end';
  }, [canScrollRight]);
  var onScrollRight = useCallback(function () {
    if (canScrollRight) {
      setCurrentTabIndex(function (prev) {
        return prev + 1;
      });
    }
  }, [canScrollRight]);
  var style = useMemo(function () {
    if (!!listRef && !!listRef.current) {
      var listEl = listRef.current;
      var tabElements = listEl.querySelectorAll('li');
      if (!Array.from(tabElements).length) {
        return null;
      }
      var left = 0;
      return /*#__PURE__*/React.createElement("style", null, Array.from(tabElements).map(function (tabEl, idx) {
        var width = tabEl.getBoundingClientRect().width;
        var matchingTab = tabs[idx];
        var tabId = matchingTab ? matchingTab.id : '';
        if (idx < currentTabIndex) {
          left = left - width;
          return ".js-tab-".concat(tabId, " { left: ").concat(left, "px; opacity: 0; position: relative}");
        } else {
          return ".js-tab-".concat(tabId, " { left: ").concat(left, "px; opacity: 100; position: relative}");
        }
      }));
    }
    return null;
  }, [currentTabIndex, tabs]);
  useEffect(function () {
    var handler = function handler() {
      if (tabs.length < 2) {
        setHideArrows(true);
        return;
      }
      if (!!listRef && !!listRef.current) {
        var listEl = listRef.current;
        var listWidth = listEl.clientWidth;
        var totalTabsWidth = 0;
        var tabElements = listEl.querySelectorAll('li');
        tabElements.forEach(function (tabEl) {
          return totalTabsWidth += tabEl.clientWidth;
        });
        var _hideArrows = listWidth > totalTabsWidth;
        setHideArrows(_hideArrows);
        if (_hideArrows) {
          setCurrentTabIndex(0);
        }
      }
    };
    handler();
    window.addEventListener('resize', handler, false);
    return function () {
      window.removeEventListener('resize', handler);
    };
  }, [tabs]);
  useEffect(function () {
    if (selected === null || hideArrows) {
      return;
    }
    var selectedTabIdx = tabs.findIndex(function (tab) {
      return tab.id === selected;
    });
    if (selectedTabIdx !== -1) {
      setCurrentTabIndex(selectedTabIdx);
    }
  }, [hideArrows, selected, tabs]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, style, /*#__PURE__*/React.createElement(AdditionalIntl, {
    intl: intl,
    messages: MESSAGES,
    namespace: "@dm/components.tabs",
    path: "Tabs/TabListScrollable/locales/TabListScrollable"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.scrollContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.scrollButtonContainerLeft
  }, /*#__PURE__*/React.createElement(Tooltip, {
    i18nKey: leftTooltip
  }, function (_ref2) {
    var ref = _ref2.ref,
      labelledby = _ref2.labelledby,
      events = _ref2.events;
    return /*#__PURE__*/React.createElement(CircleButton, Object.assign({
      ref: ref,
      "aria-labelledby": labelledby,
      className: cs(_defineProperty({}, styles.hiddenButton, hideArrows), 'auto-scroll-tabs-left'),
      disabled: !canScrollLeft,
      onClick: onScrollLeft
    }, events), /*#__PURE__*/React.createElement(Icon, {
      height: 18,
      width: 18
    }, /*#__PURE__*/React.createElement(DirectionalArrow, {
      height: 18,
      width: 18
    })));
  })), /*#__PURE__*/React.createElement("ul", {
    ref: listRef,
    role: "tablist",
    className: cs(styles.list, "".concat(styles[align]), 'auto-scrollable-tabs-list', _defineProperty({}, styles.compact, compact))
  }, tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement(Tab, {
      key: tab.id,
      className: cs("js-tab-".concat(tab.id), 'auto-scrollable-tab'),
      id: tab.id,
      i18n: tab.i18n,
      scrollableTab: true
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.scrollButtonContainerRight
  }, /*#__PURE__*/React.createElement(Tooltip, {
    i18nKey: rightTooltip
  }, function (_ref3) {
    var ref = _ref3.ref,
      labelledby = _ref3.labelledby,
      events = _ref3.events;
    return /*#__PURE__*/React.createElement(CircleButton, Object.assign({
      ref: ref,
      "aria-labelledby": labelledby,
      className: cs(_defineProperty({}, styles.hiddenButton, hideArrows), 'auto-scroll-tabs-right'),
      disabled: !canScrollRight,
      onClick: onScrollRight
    }, events), /*#__PURE__*/React.createElement(Icon, {
      className: styles.iconRight,
      height: 18,
      width: 18
    }, /*#__PURE__*/React.createElement(DirectionalArrow, {
      height: 18,
      width: 18
    })));
  })))));
}
export default injectIntl(TabListScrollable);